import { H2, Main, Paragraph } from "App/global-style";
import React, { useEffect } from "react";

import Box from "@storeblocks/box";
import { Illustration as FailureIllustration } from "@storeblocks/icon";
import { useAlertReport } from "Components/Form/Alert/alertHooks";
import { ContactMeButton } from "Components/Form/ContactMeButton/ContactMeButton";
import { useTexts } from "Components/TextContext";
import { IllustrationName } from "Constants/constants";
import { useTileTexts } from "Store/texts/hooks";
import { setDocumentTitle } from "Utils/navigation/navigationUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";

export const LoginErrorPage = (): React.ReactElement => {
  const { getText } = useTexts();
  const contactMeToggle = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1881_CONTACT_ME,
  );
  const [
    {
      checkPriceProductIntroTile: { loginError },
    },
    lang,
  ] = useTileTexts();

  useAlertReport({
    alertId: "error-login",
    title: "User could not be logged in",
  });

  useEffect(() => {
    setDocumentTitle(getText("documenttitle.error.login"));
  });

  return (
    <Main>
      <Box flexDirection="column">
        <Box justifyContent="center">
          <FailureIllustration name={IllustrationName.CUSTOMER_SERVICE_WOMAN} />
        </Box>
        <Box p={24} flexDirection="column">
          <H2 id="main">{loginError.header[lang]}</H2>
          <Paragraph>{loginError.desc[lang]}</Paragraph>
          {contactMeToggle && <ContactMeButton />}
        </Box>
      </Box>
    </Main>
  );
};
